<template>
  <div class="cards">
    <slot />
  </div>
</template>
<style lang="scss" scoped>
.cards {
  display: flex;
  justify-content: space-between;
}
</style>
